import { getApiConfig } from './default-api';

const _apiConfig = getApiConfig({ baseApiUrl: '', oldDevApi: '' });

export const DEFAULT_CONFIG = {
  nodeEnv: 'development',
  production: false,
  isServer: false,
  // for prerender
  host: 'http://localhost:8000',
  widget: {
    enabled: false,
    key: '4EeujEZ9vjbUz4PE',
    scriptSrc: 'https://s3.eu-central-1.amazonaws.com/cakeiteasy-widget-dev/cie-widget.js'
  },
  raven: {
    dsn: 'https://1c211df86429ac7c03141cd0cad80326@o4509688901074944.ingest.de.sentry.io/4509689207390288',
  },
  sentryIgnoredApiErrors: {
    [_apiConfig.users.current]: [401],
    [_apiConfig.users.login]: [401],
  },
  // 0: the request never completed (connection dropped, page closed)
  sentryIgnoredApiErrorsStatuses: [0, 404],
  analytic: {
    hotjar: '347611',
    googleTag: 'GTM-P6VX63',
    // ga4Keys: ['G-XG34KB4820'],
    postHog: 'phc_RN8sdf9eaS7xGeQ1H9XHQ63qO8bU7PAWlYpf3fIL4cs',
    // mixpanel: '2659e9dc421ad79606b2d13e2c0dedd6',
  },
  countryDomainUrls: {
    'SE': 'http://dev.cakeiteasy.se/',
    'NO': 'http://dev.cakeiteasy.no/'
  },
  countryDomainsMap: {
    'SE': 'se',
    'NO': 'no',
    'no': 'NO',
    'se': 'SE'
  },
  paymentPrefilling: {
    clearStorageOnBakeryCartUpdate: false
  },
  availableDomains: ['no', 'se'],
  defaultDomainName: 'no',
  allowCrossDomainLinking: true,
  crossSiteForbiddenLocations: {
    'SE': [],
    'NO': ['stockholm']
  },
  cakesCategoryId: 2,
  cakesNameIds: {
    en: 'cakes-2',
    no: 'kaker-2',
    se: 'tartor-2'
  },
  giftCards: {
    url: 'https://buy-dev.diggecard.com/no/giftcard/',
  }
};
